import { render, staticRenderFns } from "./profileKycDetails.vue?vue&type=template&id=72167b1f"
import script from "./profileKycDetails.vue?vue&type=script&lang=js"
export * from "./profileKycDetails.vue?vue&type=script&lang=js"
import style0 from "./profileKycDetails.vue?vue&type=style&index=0&id=72167b1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports